<div :class="colums">
    <div class="tile fadeIn" :class="{'tile--mobile': userStore.mobile, type, 'tile--swap': tile.playStream.status !== 'idle' }" v-if="performer">
        <div class="tile__information">
            <div class="tile__information--nickname"><span>{{ performer.nickname }}</span></div>
            <div class="tile__information--status"><span :class="'status teaser'"></span></div>
        </div>
        <div class="tile__block teaser">
            <div class="tile__block--labels">
                <div class="label teaser">{{ $t('general.labels.teaser') }}</div>
            </div>
            <div class="tile__block--player" @click="swap(tile.performer)" v-if="tile.playStream">    
                <Spinner v-if="tile.playStream.status != 'idle'"/>
                <player v-if="tile.playStream.status === 'idle'" :key="tile.playStream.id" v-bind="tile.playStream" @status-change="teaserStore.tileStatusChange($event, tile.performer)" v-model:audio="audio" :debug="false"></player>
            </div>
            <span class="tile__block--advert">{{ performer.advertNumber }}</span>
        </div>
    </div>
</div>